<template>
  <div>
    <HeadlineContainer headline="Change Password" :breadcrumbs="[{text: 'Change Password'}]"/>

    <div class="container">
      <div class="panel panel-default">
        <div class="panel-body">
          <form @submit.prevent="submit" class="form-horizontal">
            <PasswordFormGroup
                v-model="data.password"
                name="password"
                label="Password"
                :error="getError('password')"
            />

            <PasswordFormGroup
                v-model="data.password_confirmation"
                name="password_confirmation"
                label="Password Confirmation"
                :error="getError('password_confirmation')"
            />

            <hr>

            <SubmitFormGroup button-class="btn-black"/>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import PasswordFormGroup from '@/vendor/forms/FormGroups/Horizontal/Password'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {HeadlineContainer, PasswordFormGroup, SubmitFormGroup},

  mixins: [Errors],

  props: ['id'],

  data() {
    return {
      data: {}
    }
  },

  methods: {
    submit() {
      http.put('/api/v2/password', this.data)
          .then(() => {
            notify.success('The password was changed')

            this.reset()
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.data = {}

      this.errors = {}
    }
  }
}
</script>
